/**
 * Backend API adresi – tek kaynak.
 * Geliştirmede (npm start): boş = istekler proxy ile gider, CORS olmaz.
 * Üretimde veya REACT_APP_BACKEND_URL tanımlıysa: o adres kullanılır.
 */
const normalizeBackendUrl = (url) => {
  const u = (url || "").trim();
  if (!u) return "";
  return u
    .replace(/\/+$/, "")
    .replace(/\/api$/i, "")
    .replace("127.0.0.1:8002", "127.0.0.1:8000")
    .replace("localhost:8002", "localhost:8000");
};

const isDev = typeof process !== "undefined" && process.env.NODE_ENV === "development";
const raw = process.env.REACT_APP_BACKEND_URL;

// Runtime host kontrolü: page localhost / 127.0.0.1 / 0.0.0.0 üzerinde
// yüklendiyse, BACKEND_URL DAİMA "" (proxy zorunlu — cookie SameSite uyumu).
// Production dışı her host bu kategoriye girer; build-time `isDev` flag'i
// cache yüzünden eski değer dönerse bile bu runtime kontrol kurtarır.
function _isLocalDevHost() {
  if (typeof window === "undefined") return false;
  try {
    const host = (window.location && window.location.hostname) || "";
    return host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0";
  } catch (_) {
    return false;
  }
}

// `BACKEND_URL` ve `API` runtime-computed olarak export edilir. Bundle cache
// eski değeri tutsa bile sayfa yüklendiğinde window.location üzerinden
// karar verilir → tüm "import { BACKEND_URL }" tüketicileri otomatik düzelir.
function _computeBackendUrl() {
  if (_isLocalDevHost()) return "";
  if (isDev) return raw ? normalizeBackendUrl(raw) : "";
  return raw ? normalizeBackendUrl(raw) : "http://127.0.0.1:8000";
}

export const BACKEND_URL = _computeBackendUrl();
export const API = BACKEND_URL || "";
